<div class="jump-list section">
    <div class="jump-list">
        <div class="jump-list__container">
                <ul class="list">
                    <app-jump-list-item itemName="Game Catalog" [targetElement]="prizeGrid"></app-jump-list-item>    
                    <app-jump-list-item itemName="Redemptions" [targetElement]="myPrizeList" ></app-jump-list-item>
                    <app-jump-list-item itemName="Activity" [targetElement]="activity"></app-jump-list-item>
                </ul>
        </div>
    </div>
</div>